/**
 * @file 领券服务
 * @author fuqiang15
 */

import FormModel from '../BaseFormModel';
import {omit} from 'lodash';

export default class LotteryServiceFormModel extends FormModel {
    /**
     * @override
     */
    title = '';

    serviceType = 'lottery';

    formData = {
        appId: '',
        name: '',
        mailReceiver: '',
        zipPassword: '',
        description: '',
        awards: [],
        submitType: null
    };

    prepareData(data) {
        data = {
            ...super.prepareData(data),
            mailReceiver: data.mailReceiver,
            zipPassword: data.zipPassword
        };
        // 之前一直传递了mailReceiver等，而且update不传会error
        data.awards = JSON.stringify(data.awards.map((i, idx) => {
            // 旧版也维护了这index，兼容下吧
            i.index = idx;
            let omitKeys = i.availablePerDay ? 'id' : ['id', 'availablePerDay'];
            return omit(i, omitKeys);
        }));
        return data;
    }

}
